module.exports = __webpack_public_path__ + "static/media/user_stub.91e81803.jpeg";